import { m, useMotionValue, useSpring } from 'motion/react'
import { useEffect, useState } from 'react'

// A trailing ring + tight dot replacing the system cursor, the small
// "this site was actually designed" signal that poch.studio and jamm.co
// both use. Only on devices with a real mouse (`pointer: fine`) -- it has
// no meaning on touch, and prefers-reduced-motion visitors keep the
// system cursor since this is pure decoration, not a control.
export function CursorDot() {
  const x = useMotionValue(-100)
  const y = useMotionValue(-100)
  const ringX = useSpring(x, { damping: 30, stiffness: 300, mass: 0.5 })
  const ringY = useSpring(y, { damping: 30, stiffness: 300, mass: 0.5 })
  const [active, setActive] = useState(false)
  const [hovering, setHovering] = useState(false)

  useEffect(() => {
    const fine = window.matchMedia('(pointer: fine)').matches
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    if (!fine || reduceMotion) return

    document.body.classList.add('fs-cursor-none')
    setActive(true)

    function onMove(e: PointerEvent) {
      x.set(e.clientX)
      y.set(e.clientY)
      const target = e.target as HTMLElement
      setHovering(Boolean(target.closest('[data-cursor="link"]')))
    }

    window.addEventListener('pointermove', onMove)
    return () => {
      document.body.classList.remove('fs-cursor-none')
      window.removeEventListener('pointermove', onMove)
    }
  }, [x, y])

  if (!active) return null

  return (
    <>
      <m.div
        aria-hidden="true"
        className="pointer-events-none fixed top-0 left-0 z-[70] h-2 w-2 rounded-full bg-flow"
        style={{ x, y, translateX: '-50%', translateY: '-50%' }}
      />
      <m.div
        aria-hidden="true"
        className="pointer-events-none fixed top-0 left-0 z-[70] rounded-full border border-flow/60"
        animate={{ width: hovering ? 56 : 32, height: hovering ? 56 : 32, opacity: hovering ? 0.9 : 0.5 }}
        transition={{ duration: 0.2, ease: 'easeOut' }}
        style={{ x: ringX, y: ringY, translateX: '-50%', translateY: '-50%' }}
      />
    </>
  )
}
